<template>
  <div>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>{{loader_message}}</h3>
        </div>
      </div>
    </div>
    <CModal
      v-show="settlementActionModal"
      @close="closeSettlementActionModal"
      footer
    >
      <template v-slot:title>
        <h5 class=" fw-bold">Run Settlement</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="form-group">
            <label for="">Amount</label>
            <input
              type="text"
              class="form-control"
              v-model="settlement_amount"
              placeholder="Enter Amount"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class=" btn btn-secondary" @click="closeSettlementActionModal">
          Close
        </button>
        <button class=" btn btn-primary" @click="settlementAction">
          <span class="custom-loader" v-if="settlementActionLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait</span
            >
          </span>
          <span v-else>
            Perform Action
          </span>
        </button>
      </template>
    </CModal>
    <div class="rider--main-content" v-if="terminalDetails">
      <div @click="$router.go(-1)" class="arrow_text cursor-pointer">
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        ></chevron-left-icon>
        <span class="back">Back</span>
      </div>
      <h1 class="mt-2 mb-3 font-regular">
        {{ terminalDetails.terminalID }} 's Terminal
      </h1>
      <div class="row">
        <div class="col-xl-4 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="'#7987A1'"
            :text="'Terminal Balance'"
            :currency="true"
            :value="terminalDetails.balance"
          />
        </div>
        <div class="col-xl-4 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="'#7987A1'"
            :text="'Account Number'"
            :currency="false"
            :value="terminalDetails.account_number"
          />
        </div>
      </div>
      <TerminalStats :obj="stat" v-if="!pageLoading && stat !== null" />
      <div class="row mb-5">
        <div class="col-lg-12">
          <CScrollbar
            class="nav nav-tabs nav-overflow header-tabs"
            :settings="psSettings"
            tag="ul"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
                >Terminal Info</a
              >
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
                >Devices</a
              >
            </li>
            <li class="nav-item" v-if="permissions.includes('payments')">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 3"
                v-bind:class="[activetab === 3 ? 'active' : '']"
                >Transactions</a
              >
            </li>
            <li
              class="nav-item"
              v-if="permissions.includes('transfer-charges')"
            >
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 4"
                v-bind:class="[activetab === 4 ? 'active' : '']"
                >Charges</a
              >
            </li>
            <li class="nav-item" v-if="permissions.includes('view-terminal')">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 6"
                v-bind:class="[activetab === 6 ? 'active' : '']"
                >Statement</a
              >
            </li>
          </CScrollbar>
        </div>
      </div>
      <div v-if="terminalDetails !== null && activetab === 6">
        <div class="row">
          <div class="col-md-4">
            <input type="date" v-model="start_date" class="form-control" />
          </div>
          <div class="col-md-4">
            <input type="date" v-model="end_date" class="form-control" />
          </div>
          <div class=" col-md-auto">
            <button
              class="btn btn-primary"
              @click.prevent="getStatement"
              :disabled="!statementFormIsValid || statement_loading"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="row" v-if="activetab === 1">
        <div class="col-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Profile Information</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <button
                  @click="showSettlementModal"
                  type="button"
                  v-if="permissions.includes('update-terminal-settlement-status')"
                  class="btn btn-success w-auto"
                >
                  Settlement Settings
                </button>
                <button
                  @click="showSettlementActionModal"
                  type="button"
                  v-if="permissions.includes('run-terminal-settlement')"
                  class="btn btn-danger w-auto"
                >
                  Run Settlement
                </button>
                <button
                  @click="generateAccountNumber"
                  type="button"
                  v-if="permissions.includes('generate-terminal-account-number')"
                  class="btn btn-danger w-auto"
                >
                  Generate Account Number
                </button>
                <button
                  @click="checkTerminalForInflow"
                  type="button"
                  v-if="permissions.includes('check-terminal-inflow')"
                  class="btn btn-danger w-auto"
                >
                  Check Terminal For Inflow
                </button>
                <form @submit.prevent="updateTerminalStatus">
                  <!-- General Information -->
                  <div class="actions-toolbar pb-2">
                    <h5 class="actions-title">General Information</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="last_name">Terminal ID</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="terminalDetails.terminalID"
                          placeholder="Full Name"
                          name="lastname"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="full_name">Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="terminalDetails.name"
                          placeholder="Full Name"
                          name="firstname"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="email_address">Address</label>
                        <input
                          type="email"
                          id="email_address"
                          class="form-control"
                          v-model.trim="terminalDetails.address"
                          placeholder="Email Address"
                          name="email_address"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="email_address">City</label>
                        <input
                          type="email"
                          id="email_address"
                          class="form-control"
                          v-model.trim="terminalDetails.city"
                          placeholder="Email Address"
                          name="email_address"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="email_address">State</label>
                        <input
                          type="email"
                          id="email_address"
                          class="form-control"
                          v-model.trim="terminalDetails.state.name"
                          placeholder="Email Address"
                          name="email_address"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="phone_number">Phone Number</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="terminalDetails.phone_number"
                          placeholder="Phone Number"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Status</label>
                        <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="terminalDetails.terminal_status"
                        >
                          <option value="active" class="mb-2">Active</option>
                          <option value="inactive" class="mb-2"
                            >Inactive</option
                          >
                          <option value="suspended" class="mb-2"
                            >Suspended</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="button"
                    :disabled="
                      updateStaffLoading ||
                        !permissions.includes('update-terminal-status')
                    "
                    :class="
                      permissions.includes('update-terminal-status')
                        ? ''
                        : 'disabled cursor-not-allowed'
                    "
                  >
                    <span class="custom-loader" v-if="updateStaffLoading">
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial;"
                        >Updating Terminal...</span
                      >
                    </span>
                    <span v-else>Update Terminal Status</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="activetab === 2">
        <div class="col-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Devices</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div v-if="device_terminals">
                  <CDataTable
                    :items="device_terminals"
                    :fields="device_fields"
                    :items-per-page="small ? 10 : 5"
                    pagination
                    sorter
                    tableFilter
                  >
                    <template #serial_no="{item}">
                      <td>{{ item.device.serial_no }}</td>
                    </template>
                    <template #deviceID="{item}">
                      <td>{{ item.device.deviceID }}</td>
                    </template>
                    <template #imei="{item}">
                      <td>{{ item.device.imei }}</td>
                    </template>
                    <template #model="{item}">
                      <td>{{ item.device.model }}</td>
                    </template>
                    <template #assignment_status="{item}">
                      <td>{{ item.device.assignment_status }}</td>
                    </template>
                    <template #manufacturer="{item}">
                      <td>{{ item.device.manufacturer }}</td>
                    </template>
                  </CDataTable>
                </div>
                <div v-else>
                  <div class="text-center">
                    <h4>No Devices Found</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="" v-if="activetab === 3">
        <div class="row align-items-end my-4">
          <div class="col-xl-3 col-lg-6 col-12 px--5">
            <div class="form-group">
              <label>Select Period</label>
              <select class="form-control" v-model="periodParams">
                <option value selected disabled>Please Select Period</option>
                <option value="range">Range</option>
                <option value="30-days">30-day</option>
                <option value="7-days">7-day</option>
              </select>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-6 col-12 px--5"
            v-if="periodParams === 'range'"
          >
            <div class="form-group">
              <label>Start Date</label>
              <input type="date" class="form-control" v-model="start_date" />
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-6 col-12 px--5"
            v-if="periodParams === 'range'"
          >
            <div class="form-group">
              <label>Stop Date</label>
              <input type="date" class="form-control" v-model="stop_date" />
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-12 px--5">
            <div class="form-group">
              <label>Transaction Type</label>
              <select
                name="plan"
                id
                class="form-control"
                v-model="transaction_type"
              >
                <option value selected>Select Type</option>
                <option value="inter-bank">Inter Bank Transfer</option>
                <option value="intra-bank">Intra Bank Transfer</option>
                <option value="airtime">Airtime</option>
                <option value="data">Data</option>
                <option value="power">Power</option>
                <option value="TV">TV</option>
                <option value="cashout">Cashout</option>
              </select>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-12 px--5">
            <div class="form-group">
              <label>Search By Reference</label>
              <input
                type="text"
                class="form-control"
                v-model="searchParams"
                placeholder="Search By Reference"
              />
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-12 px--5">
            <div class="form-group">
              <button @click.prevent="getTransaction(1)" class="button btn">
                <span class="custom-loader" v-if="loading">
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Please Wait</span
                  >
                </span>
                <span v-else>Submit</span>
              </button>
            </div>
          </div>
        </div>
        <div class="card card--no-shadow">
          <div class="card-header">
            <slot name="header">
              <h4 class="card-title">Transactions</h4>
            </slot>
          </div>
          <div class="card-content">
            <div class="card-body">
              <!-- <transaction-data-table
            ref="reports"
            :start_date="startDate"
            :stop_date="stopDate"
            :plan="planQuery"
            :search="searchQuery"
          /> -->
              <CDataTable
                :items="payments"
                :fields="fields"                
                sorter
                tableFilter
              >
                <template #created_at="{item}">
                  <td class="table--action-mobile">
                    {{ item.created_at | date }}
                  </td>
                </template>
                <template #action="{item}">
                  <td class="table--action-mobile">
                    <router-link
                      :event="
                        permissions.includes('view-payment') ? 'click' : ''
                      "
                      class="button"
                      :class="
                        permissions.includes('view-payment')
                          ? ''
                          : 'disabled cursor-not-allowed'
                      "
                      :to="{
                        name: 'Payment',
                        params: { slug: item.transaction_reference }
                      }"
                    >
                      View
                    </router-link>
                  </td>
                </template>
              </CDataTable>
              <CPagination
                :activePage.sync="next_page"
                :pages="total"
                :onActivePageChange="onPageChange()"
              ></CPagination>
            </div>
          </div>
        </div>
      </div>
      <div class="" v-if="activetab === 4">
        <ChargesSettingsComponent :terminal_id="slug" />
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";
import CScrollbar from "@/components/CScrollbar";
import CDataTable from "@/components/CDataTable.vue";
import CCard from "@/components/CCard";
import CModal from "@/components/CModal";
import TerminalStats from "../../components/TerminalStats.vue";
import CPagination from "@/components/CPagination.vue";
import ChargesSettingsComponent from "../settings/ChargesSettingsComponent.vue";
const device_fields = [
  "serial_no",
  "deviceID",
  "imei",
  "manufacturer",
  "model",
  "assignment_status",
  "created_at"
];

const fields = [
  // "created_at",
  "description",
  "transaction_reference",
  "type",
  "status",
  // "method",
  "total_amount",
  "date",
  "action"
];
export default {
  name: "ViewTerminal",
  components: {
    CScrollbar,
    CDataTable,
    CPagination,
    TerminalStats,
    CModal,
    CCard,
    ChargesSettingsComponent
  },
  data() {
    return {
      fields,
      statement_loading: false,
      small: true,
      device_fields,
      pageLoading: false,
      loader_message: "Loading Terminal Details...",
      activetab: 1,
      modalIsLarge: true,
      terminalDetails: null,
      roles: [],
      getRolesLoading: false,
      updateStaffLoading: false,
      device_terminals: null,
      transaction_type: "",
      statusParams: "",
      periodParams: "",
      start_date: "",
      end_date: "",
      stop_date: "",
      searchParams: "",
      payments: [],
      current: 1,
      total: 1,
      next_page: 1,
      tLoading: false,
      error_status: false,
      loading: false,
      stat: null,
      statement: null,
      settlementModal: true,
      settlementActionModal: false,
      settlement_amount: "",
      settlementActionLoading: false
    };
  },
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  computed: {    
    statementFormIsValid() {
      return this.start_date !== "" && this.end_date !== "";
    },
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    showSettlementActionModal() {
      this.settlementActionModal = true;
    },
    closeSettlementActionModal() {
      this.settlementActionModal = false;
    },
    showSettlementModal() {
      this.settlementModal = true;
    },
    closeSettlementModal() {
      this.settlementModal = false;
    },
    async settlementAction(){
      this.settlementActionLoading = true;
      try {
        const response = await ApiService.post(
          "terminal/run-settlement",
          {
            terminalID: this.slug,
            amount : this.settlement_amount
          }
        );

        Swal.fire({
          title: "Success",
          text: response.data.smessage,
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
          confirmButtonText: "OK"
        });

        setTimeout(() => {
          this.closeSettlementActionModal();
          this.settlement_amount= "";
          this.getTerminal();
        }, 3000);

        this.settlementActionLoading = false;
      } catch (error) {
        console.log(error.response);
        this.settlementActionLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getStatement() {
      this.statement_loading = true;
      try {
        let response = await ApiService.post("terminal/statement", {
          start_date: this.start_date,
          end_date: this.end_date,
          terminal_id: this.terminalDetails.id
        });

        this.statement = response.data.data;
        this.statement_loading = false;
      } catch (error) {
        console.log(error.response);
        this.statement_loading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async getTerminal() {
      try {
        this.pageLoading = true;
        this.loader_message = "Loading Terminal Details...";
        const response = await ApiService.get(
          `terminal/get-terminal/${this.slug}`
        );

        this.terminalDetails = response.data.data;
        if (this.terminalDetails !== null) {
          this.getTransaction(1);
          this.terminalStats();
        }
        this.device_terminals = response.data.data.device_terminals;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
        console.log(error.response);
      }
    },
    async updateTerminalStatus() {
      // let up = "active,in-active,suspended";
      this.updateStaffLoading = true;
      console.log(this.terminalDetails.terminal_status);
      try {
        const response = await ApiService.post(
          "terminal/update-terminal-status",
          {
            terminalID: this.slug,
            terminal_status: this.terminalDetails.terminal_status
          }
        );

        Swal.fire({
          title: "Success",
          text: response.data.smessage,
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
          confirmButtonText: "OK"
        });

        this.updateStaffLoading = false;
      } catch (error) {
        console.log(error.response);
        this.updateStaffLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async updateterminalDetails() {
      let data = {
        first_name: this.terminalDetails.first_name,
        last_name: this.terminalDetails.last_name,
        email: this.terminalDetails.email,
        phone_number: this.terminalDetails.phone_number,
        role: this.terminalDetails.role,
        profile_status: this.terminalDetails.profile_status
      };
      try {
        this.updateStaffLoading = true;
        const response = await ApiService.post(
          `user/update-staff/${this.slug}`,
          data
        );
        this.updateStaffLoading = false;

        Swal.fire({
          title: "Success",
          text: "Staff Updated Successfully",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
          confirmButtonText: "OK"
        });
      } catch (error) {
        console.log(error.response);
        this.updateStaffLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getTransaction(page) {
      try {
        this.tLoading = true;
        const response = await ApiService.get(
          `payment/all?page=${page}&payment_type=${this.transaction_type}&period=${this.periodParams}&status=${this.statusParams}&search=${this.searchParams}&start_date=${this.start_date}&stop_date=${this.stop_date}&terminal_id=${this.terminalDetails.id}`
        );
        this.payments = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.tLoading = false;
      } catch (error) {
        this.tLoading = false;
        console.log(error.response);
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        console.log(this.next_page);
        if (this.error_status == false) {
          this.getTransaction(this.next_page);
        }
      }
    },
    async generateAccountNumber(){
      const swalResponse = await Swal.fire({
        title: `<div>
        <h5 class="fw-bold">Generate Reserved Account for Termina</h5>
            </div>`,
        text: "Are you sure you want to generate account number for this terminal?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!",
      });
      if (!swalResponse.isConfirmed) {
          return;
      }

      let _data = {
        terminalID: this.slug
      }
      this.pageLoading = true;
      this.loader_message = "Generating Account Number...";
      try {
        const response = await ApiService.post(
          `terminal/reserve-account-number`,
          _data
        );
        this.pageLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
          confirmButtonText: "OK"
        });
        this.getTerminal();
      } catch (error) {
        this.pageLoading = false;
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async checkTerminalForInflow(){
      const swalResponse = await Swal.fire({
        title: `<div>
        <h5 class="fw-bold">Check Terminal for Infow</h5>
            </div>`,
        text: "Are you sure you want to check terminal for inflow?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!",
      });
      if (!swalResponse.isConfirmed) {
          return;
      }

      let _data = {
        account_number: this.terminalDetails.account_number || "",
      }
      this.pageLoading = true;
      this.loader_message = "Checking Terminal for Inflwo...";
      try {
        const response = await ApiService.post(
          `terminal/check-terminal-for-inflow`,
          _data
        );
        this.pageLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
          confirmButtonText: "OK"
        });
        this.getTerminal();
      } catch (error) {
        this.pageLoading = false;
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async terminalStats() {
      try {
        const res = await ApiService.get(
          `terminal/stats/${this.terminalDetails.id}`
        );
        this.stat = res.data.data;
      } catch (error) {
        console.log(error.response);
      }
    }
  },
  mounted() {
    this.getTerminal();

    // this.getTransaction(1);
  }
};
</script>

<style scoped></style>
